import { Component, Input, OnDestroy, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { IdService } from '../../shared/services/id.service';
import { ICrumb } from './breadcrumbs.types';

@Component({
	selector: 'rbc-breadcrumbs',
	templateUrl: './breadcrumbs.component.html',
	styleUrls: ['./breadcrumbs.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class BreadcrumbsComponent implements OnDestroy, OnChanges {
	@Input() id: string;
	@Input() items: ICrumb[];

	constructor(private idService: IdService) {
		this.id = this.idService.generate();
	}

	ngOnDestroy(): void {
		if (this.idService) {
			this.idService.remove(this.id);
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (Array.isArray(this.items)) {
			this.items = this.items.filter(item => {
				return !!item.text && item.text !== '';
			});
		}
	}

	/* utils */
	getLinkClass(link: string) {
		return link && link !== '#' ? 'breadcrumb-link' : '';
	}
}
